const cartValidation = {
  success: document.getElementById('jsSuccessMessage') as HTMLElement,
  error: document.getElementById('jsErrorMessage') as HTMLElement | null,
  dummyCheckoutButtons: document.querySelectorAll('.jsDummyBtn') as NodeListOf<HTMLButtonElement>,
  realCheckoutButtons: document.querySelectorAll('.jsCheckoutBtn') as NodeListOf<HTMLButtonElement>,
  postcodeInput: document.getElementById('ship_zip') as HTMLInputElement,
  countrySelect: document.getElementById('jsCheckCountry') as HTMLSelectElement | null,
  isFormSubmitted: false,
  currentCountry: '',  
  previousPostcode: '',  

  init() {
    this.clearPostcodeError();
    this.hidePostcodeWrap();
    this.hideRestrictMessage();

    const hasRestrictedProduct = this.checkForRestrictedProducts();
    const selectedCountry = this.getSelectedCountry();

    this.currentCountry = selectedCountry;  
    this.previousPostcode = sessionStorage.getItem('postcode') || '';  

    this.handleCountrySelection(selectedCountry, hasRestrictedProduct);
    this.checkFormSubmissionState();
    this.addCountrySelectListener();
    this.addPostcodeValidation();
  },

  handleCountrySelection(selectedCountry: string, hasRestrictedProduct: boolean) {
    if (selectedCountry === 'AU') {
      this.handleAustraliaCountrySelection(hasRestrictedProduct);
    } else {
      this.handleNonAustraliaCountrySelection();
    }
  },

  handleAustraliaCountrySelection(hasRestrictedProduct: boolean) {
    if (hasRestrictedProduct) {
      this.applyAustraliaRestrictions();
    } else {
      this.showNormalCheckoutButtons();
      this.removeActiveClassFromPostcode();
      this.showDefaultMessage();
      this.showShippingSummary();
      this.hidePostcodeWrap(); 
    }
  },

  handleNonAustraliaCountrySelection() {
    this.showNormalCheckoutButtons();
    this.removeActiveClassFromPostcode();
    this.showDefaultMessage();
    this.showShippingSummary();
    this.hidePostcodeWrap(); 

    if (this.error) {
      this.error.style.display = 'none';
    }

    if (this.postcodeInput) {
      this.postcodeInput.classList.remove('activeClass');
    }
  },

  addPostcodeValidation() {
    const postcodeInput = this.postcodeInput;
  
    if (postcodeInput) {
      postcodeInput.addEventListener('input', () => {
        const postcode = postcodeInput.value.trim();
        const selectedCountry = this.getSelectedCountry();
        const restrictedProductsExist = this.checkForRestrictedProducts();
  
   
        if (!restrictedProductsExist) {
          this.clearPostcodeError();
          this.hideShippingSummary();
          this.hidePostcodeWrap();
          this.hideRestrictMessage();
          return; 
        }
  
       
        if (postcode === '') {
          this.showDummyCheckoutButtons();  
          this.hideDefaultCheckoutButtons(); 
       
        } else if (postcode.startsWith('4')) {
        
          this.showDummyCheckoutButtons();
          this.hideDefaultCheckoutButtons();
        } else {
         
          this.showDefaultCheckoutButtons();
          this.hideDummyCheckoutButtons();
          this.clearPostcodeError(); 
        }
  
   
        if (selectedCountry === 'AU') {
          this.validatePostcodeForAustralia(postcodeInput, postcode);
        } else {
          this.clearPostcodeError();
        }
  
        this.storePostcodeInSession(postcode);
      });
    }
  },
  

showDummyCheckoutButtons() {
  this.dummyCheckoutButtons.forEach((button) => button.style.display = 'block');
  
  this.realCheckoutButtons.forEach((button) => button.style.display = 'none');
},


hideDummyCheckoutButtons() {
  this.dummyCheckoutButtons.forEach((button) => button.style.display = 'none');
},


showDefaultCheckoutButtons() {
  this.realCheckoutButtons.forEach((button) => button.style.display = 'block');
  this.dummyCheckoutButtons.forEach((button) => button.style.display = 'none');
}
,

hideDefaultCheckoutButtons() {
  this.realCheckoutButtons.forEach((button) => button.style.display = 'none');
},

  validatePostcodeForAustralia(postcodeInput: HTMLInputElement, postcode: string) {

    this.clearPostcodeError();
    this.hideShippingSummary();
    this.hidePostcodeWrap();
    this.hideRestrictMessage();

    if (postcode.startsWith('4')) {
 
      this.showPostcodeWrap();
      this.showRestrictMessage();
      this.addActiveClassToDummyButton(true);
      this.addActiveClassToPostcodeIfNeeded(postcode);
    } else if (postcode === '') {
      
      this.handleError('Please enter your postcode');
      this.showPostcodeErrorStyles(true);
      this.addActiveClassToDummyButton(false);
      this.addActiveClassToPostcodeIfNeeded(postcode);
    } else {
      this.addActiveClassToDummyButton(false);
      this.addActiveClassToPostcodeIfNeeded(postcode);
      this.showPostcodeErrorStyles(false);
    }

    this.storePostcodeInSession(postcode);
  },

  addActiveClassToPostcodeIfNeeded(postcode: string) {
    if (this.postcodeInput) {
      if (postcode.startsWith('4')) {
        this.addActiveClassToDummyButton(true);
        this.postcodeInput.classList.add('activeClass');
      } else {
        this.addActiveClassToDummyButton(false);
        this.postcodeInput.classList.remove('activeClass');
      }
    }
  },

  addActiveClassToDummyButton(isActive: boolean) {
    this.dummyCheckoutButtons.forEach((button) => {
      if (isActive) {
        button.classList.add('activeClass');
      } else {
        button.classList.remove('activeClass');
      }
    });
  },

  updateUIBasedOnPostcode(postcode: string) {
    const restrictedProductsExist = sessionStorage.getItem('restrictedProductsExist') === 'true';
    const shipSummary = document.getElementById('jsShipSummary');

    if (postcode === '') {
      this.clearPostcodeError();
      this.hideShippingSummary();
      this.hidePostcodeWrap();
      this.hideRestrictMessage();
    } else if (postcode.startsWith('4') && restrictedProductsExist) {
      this.showPostcodeWrap();
      this.showRestrictMessage();
      this.hideShippingSummary();
    } else if (postcode.startsWith('4')) {
      this.showPostcodeWrap();
      this.showRestrictMessage();
      this.hideShippingSummary();
    } else {

      this.showShippingSummaryIfNoRestrictedProducts(restrictedProductsExist, shipSummary);
    }
  },

  handleDummyCheckoutButtonClick() {
    this.dummyCheckoutButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const postcode = this.postcodeInput?.value.trim();
        const restrictedProductsExist = sessionStorage.getItem('restrictedProductsExist') === 'true';
        const selectedCountry = this.getSelectedCountry();

        this.clearPostcodeError();

      
        if (!restrictedProductsExist) {
          return;
        }

        if (selectedCountry === 'AU' && !postcode && restrictedProductsExist) {
          e.preventDefault();
          this.handleError('Please enter your postcode');
          this.showPostcodeErrorStyles(true);
          this.hideShippingSummary();
          this.hidePostcodeWrap();
          this.hideRestrictMessage();
        } else {
          this.storePostcodeInSession(postcode);
          this.handleRestrictedProductForAustralia(postcode);
          this.addActiveClassToPostcodeIfNeeded(postcode);  
        }
      });
    });
  },

  handleRestrictedProductForAustralia(postcode: string) {
    if (postcode?.startsWith('4')) {
      this.showPostcodeWrap();
      this.showRestrictMessage();
    } else {
      this.showNormalCheckoutButtons();
    }
  },

  showNormalCheckoutButtons() {
    this.realCheckoutButtons.forEach((button) => button.style.display = 'block');
    this.dummyCheckoutButtons.forEach((button) => button.style.display = 'none');
    sessionStorage.setItem('restrictedProductsExist', 'false');
  },

  checkForRestrictedProducts() {
    const cartProducts = document.querySelectorAll('.jsCartProd');
    return Array.from(cartProducts).some((product) => product.getAttribute('data-restrict') === 'y');
  },

  applyAustraliaRestrictions() {
    this.checkProductRestrictions();
    this.addPostcodeValidation();
    this.addCalculateShippingClick();
    this.loadStoredState();
    this.handleDummyCheckoutButtonClick();
  },

  checkProductRestrictions() {
    const restrictedProductsExist = this.checkForRestrictedProducts();
    sessionStorage.setItem('restrictedProductsExist', restrictedProductsExist.toString());
  },

  addCountrySelectListener() {
    const countrySelect = this.countrySelect;

    if (countrySelect) {
      countrySelect.addEventListener('change', () => {
        const selectedCountry = countrySelect.value;
        this.previousPostcode = sessionStorage.getItem('postcode') || ''; 

       
        this.currentCountry = selectedCountry; 
      });
    }
  },

  showShippingSummaryIfNoRestrictedProducts(restrictedProductsExist: boolean, shipSummary: HTMLElement | null) {
    if (!restrictedProductsExist && shipSummary) {
      shipSummary.style.display = 'block';
    } else {
      this.showNormalCheckoutButtons();
      this.hidePostcodeWrap();
      this.hideRestrictMessage();
    }
  },

  handleError(errorMessage: string) {
    if (this.error) {
      this.error.textContent = errorMessage;
      this.error.style.display = 'block';
    }
  },

  showPostcodeErrorStyles(isRed: boolean) {
    if (this.postcodeInput) {
      if (isRed) {
        this.postcodeInput.classList.add('errorStyle');
      } else {
        this.postcodeInput.classList.remove('errorStyle');
      }
    }

    if (this.error) {
      if (isRed) {
        this.error.style.color = 'red';
        this.error.style.display = 'block';
      } else {
        this.error.style.color = '';
        this.error.style.display = 'none';
      }
    }
  },

  showShippingSummary() {
    const shipSummary = document.getElementById('jsShipSummary');
    if (shipSummary) {
      shipSummary.style.display = 'block';
    }
  },

  hideShippingSummary() {
    const shipSummary = document.getElementById('jsShipSummary');
    if (shipSummary) {
      shipSummary.style.display = 'none';
    }
  },

  addCalculateShippingClick() {
    const calculateShippingButton = document.getElementById('jsCalculateShipping') as HTMLButtonElement;
  
    if (calculateShippingButton) {
      calculateShippingButton.addEventListener('click', () => {
       
        console.log('Calculate Shipping button clicked');
      });
    }
  },

  checkFormSubmissionState() {
    if (this.isFormSubmitted) {
      this.handleSuccess();
    }
  },

  handleSuccess() {
    if (this.success) {
      this.success.style.display = 'block';
    }

    if (this.error) {
      this.error.style.display = 'none';
    }
  },

  getSelectedCountry() {
    return this.countrySelect ? this.countrySelect.value : '';
  },

  storePostcodeInSession(postcode: string) {
    sessionStorage.setItem('postcode', postcode);
  },

  loadStoredState() {
    const postcode = sessionStorage.getItem('postcode');
    const formSubmitted = sessionStorage.getItem('formSubmitted') === 'true';

    if (!postcode) {
      this.postcodeInput.value = '';
      this.postcodeInput.classList.remove('activeClass');
      this.handleError('Please enter your postcode');
      this.showPostcodeErrorStyles(false); 
      this.hideShippingSummary();
      this.hidePostcodeWrap();
      this.hideRestrictMessage();
    } else {
      this.postcodeInput.value = postcode;
      this.clearPostcodeError();
      this.updateUIBasedOnPostcode(postcode);
      this.addActiveClassToPostcodeIfNeeded(postcode); 
    }

    if (formSubmitted) {
      this.handleSuccess();
    }
  },

  clearPostcodeError() {
    const postcodeInput = this.postcodeInput;

    if (this.error) {
      this.error.style.display = 'none';
      this.error.style.color = '';
    }

    if (postcodeInput) {
      postcodeInput.classList.remove('activeClass');
    }
  },

  hidePostcodeWrap() {
    const postcodeWrap = document.getElementById('jsPostCodeWrap');
    if (postcodeWrap) {
      postcodeWrap.style.display = 'none';
    }
  },

  showPostcodeWrap() {
    const postcodeWrap = document.getElementById('jsPostCodeWrap');
    if (postcodeWrap) {
      postcodeWrap.style.display = 'block';
    }
  },

  hideRestrictMessage() {
    const restrictMessages = document.querySelectorAll('.jsRestrictMessage');
    restrictMessages.forEach((restrictMessage) => {
      if (restrictMessage instanceof HTMLElement) {
        restrictMessage.style.display = 'none';
      }
    });
  },

  showRestrictMessage() {
    const restrictMessages = document.querySelectorAll('.jsRestrictMessage');
    restrictMessages.forEach((restrictMessage) => {
      if (restrictMessage instanceof HTMLElement) {
        restrictMessage.style.display = 'block';
      }
    });
  },

  removeActiveClassFromPostcode() {
    if (this.postcodeInput) {
      this.postcodeInput.classList.remove('activeClass');
    }
  },

  showDefaultMessage() {
    const defaultMessage = document.getElementById('jsDefaultMessage');
    if (defaultMessage) {
      defaultMessage.style.display = 'block';
    }
  }
};

export default cartValidation;